var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-4 text-xs inline-flex items-center font-bold leading-sm uppercase px-3 py-1 rounded-full",class:_vm.classes},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }